export default {
    "BENEFICIARY_TIER_TYPE": "Beneficiary",
    "TAG_ENTITY_TYPE": "Tag",
    PAGING_SETTINGS: {
      INFINITE: 'infinite',
      PAGED: 'paged',
      NONE: 'none'
    }
}